/** GPU-cheap hero background — replaces Spline WebGL on public pages. */
export default function HeroAmbientBg() {
  return <div className="ds-hero-ambient-bg" aria-hidden="true" />;
}
